import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { passwordMatchingValidatior } from '../../_helpers/validators/PasswordMatch.validator';
import { PasswordValidators } from '../../_helpers/validators/PasswordSpecificCharacter.validator';
import { AuthService } from '../../_services/auth.service';
import { SessionGuardService } from '../../_services/session-guard.service';
import { TokenService } from '../../_services/token.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  code: string = '';
  userId: string = '';
  isFormSend: boolean = false;
  isPasswordVisible: boolean = false;
  isPasswordConfirmVisible: boolean = false;
  constructor(
    private authService: AuthService,
    private tokenService: TokenService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private sessionGuard: SessionGuardService
  ) {
    this.changePasswordForm = this.fb.group(
      {
        password: [
          null,
          [
            Validators.required,
            Validators.minLength(10),
            PasswordValidators.patternValidator(new RegExp('(?=.*[()[\\]$@=.#+_^|/,“:!%*?&])'), {
              requiresSpecialChars: true,
            }),
          ],
        ],
        passwordConfirm: [null, Validators.required],
      },
      { validators: passwordMatchingValidatior, PasswordValidators }
    );
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      this.code = params['code'];
      this.userId = params['userId'];
    });
  }

  onSubmit() {
    if (this.changePasswordForm.valid) {
      const password = this.changePasswordForm.controls['password'].value;
      this.authService.ChangePassword(this.code, this.userId, password).subscribe(
        (_) => (this.isFormSend = true),
        (error) => console.log(error)
      );
    }
  }

  async GoToLogin(): Promise<void> {
    // Clearing the session reloads the other tabs, which stops an upload running there.
    if (!(await this.sessionGuard.confirmSessionChange())) return;
    // Drop any stale session first, otherwise TokenGuard sees the old token and redirects /login back to '/'.
    this.tokenService.clearSession();
    this.router.navigateByUrl('/login');
  }
}
